<div class="category-item">
  <a class="category-link" [cmsRouterLink]="categoryItem.url">
    @if (categoryItem.image) {
      <img
        class="category-img"
        [src]="categoryItem.image.url"
        loading="lazy"
        [alt]="categoryItem.name"
      />
    } @else {
      <img
        class="category-img category-img-not-found"
        src="/assets/images/misc/placeholder/placeholder.jpg"
        [alt]="categoryItem.name"
      />
    }
    <span class="category-title"
      >{{ categoryItem.name }}
      <fa-icon class="icon" [icon]="faArrowRight"></fa-icon
    ></span>
  </a>
</div>
